<template>
  <v-layout row pa-3>
    <v-flex xs12 sm8 offset-sm2>
      <v-card>
        <v-toolbar color="cyan" text tabs>
          <v-icon>person</v-icon>
          <v-toolbar-title>Profile {{ uid }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn icon>
            <v-icon>more_vert</v-icon>
          </v-btn>

          <template v-slot:extension>
            <v-tabs v-model="tab" color="cyan" grow>
              <v-tabs-slider color="yellow"></v-tabs-slider>

              <v-tab
                v-for="item in items"
                :key="item.name"
                :to="{ path: `/profiles/${uid}/${item.route}` }"
                >{{ item.name }}</v-tab
              >
            </v-tabs>
          </template>
        </v-toolbar>
        <v-card>
          <router-view></router-view>
        </v-card>
        <v-footer>
          <v-btn text fab @click.stop="$router.push({ name: 'profiles' })">
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-footer>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  components: {},
  props: {
    uid: String
  },
  data: () => ({
    loading: false,
    tab: null,
    items: [
      { name: "Info", route: "" },
      { name: "Orders", route: "orders" },
      { name: "Invoices", route: "invoices" },
      { name: "Sources", route: "sources" },
      { name: "Addresses", route: "addresses" }
    ]
  }),
  methods: {},
  mounted: function() {},
  watch: {}
};
</script>
